export const dataStore = {
    value: null as Record<string, boolean> | null
};

type QueryValue = string | string[] | undefined;

function compareVersions(left: string, right: string): number {
    const leftParts = left.split('.').map((part) => parseInt(part, 10));
    const rightParts = right.split('.').map((part) => parseInt(part, 10));
    const length = Math.max(leftParts.length, rightParts.length);

    for (let index = 0; index < length; index += 1) {
        const leftPart = leftParts[index] || 0;
        const rightPart = rightParts[index] || 0;

        if (leftPart > rightPart) {
            return 1;
        }

        if (leftPart < rightPart) {
            return -1;
        }
    }

    return 0;
}

export class QueryParameters {
    public lang: QueryValue;
    public product: QueryValue;
    public version: QueryValue;
    public link: string;
    public branch: QueryValue;

    constructor(lang: QueryValue, product: QueryValue, version: QueryValue, link: string, branch: QueryValue = undefined) {
        this.lang = lang;
        this.product = product;
        this.version = version;
        this.link = link.indexOf('/') === 0 ? link : '/' + link;
        this.branch = branch;
    }

    public static getLastVersion(): string {
        let version = '00.00.00';

        $.each(dataStore.value, (versionKey, enabled) => {
            if (enabled === true && compareVersions(versionKey, version) > 0) {
                version = versionKey;
            }
        });

        return version;
    }

    public static getFloresLastVersion(): string {
        return QueryParameters.getLastVersion();
    }

    public replace() {
        if (this.lang !== undefined) {
            this.lang = this.split(this.lang);
        }

        if (this.branch !== undefined) {
            this.branch = this.split(this.branch);
        }

        if (this.version !== undefined) {
            this.version = this.split(this.version);

            if (this.version === 'last') {
                this.version = QueryParameters.getFloresLastVersion();
            }
        }

        if (this.product !== undefined) {
            this.product = this.split(this.product);
        }

        if (typeof this.version === 'string') {
            runtime.query.replaceUrl(window.location.origin + '/' + this.version + this.link);
            return;
        }

        if (typeof this.lang === 'string' || typeof this.product === 'string' || typeof this.version === 'string') {
            runtime.cookie.autofill = false;
        }
    }

    public parametersExist(): boolean {
        return typeof this.lang === 'string' || typeof this.product === 'string' || typeof this.version === 'string';
    }

    private split(pattern: QueryValue): QueryValue {
        if (typeof pattern !== 'string') {
            return pattern;
        }

        return pattern.indexOf(';') !== -1 ? pattern.split(';') : pattern;
    }
}

export class Query {
    public path: Record<string, string>;
    public highlight: string;
    public hash: string;
    public parameters: QueryParameters;

    constructor() {
        this.highlight = '';
        this.hash = document.location.hash;
        this.path = $.getQueryParameters();

        if (this.path.link === undefined) {
            this.path.link = '/Content/Home.htm';
        }

        const search = decodeURI(document.location.search);
        if (search.indexOf('?highlight') !== -1) {
            this.highlight = search.replace(/.*\?highlight="(.*)"/, '$1');
            this.path.link = this.path.link.replace('?highlight', '');
        }

        if (search.indexOf('#') !== -1) {
            this.hash = document.location.hash;
        }

        if (this.path.product !== undefined) {
            this.path.product = this.path.product.replace('M4', 'G4');
        }
    }

    public afterLoad() {
        this.parameters = new QueryParameters(this.path.lang, this.path.product, this.path.version, this.getLink(), this.path.branch);

        if (Object.keys(this.path).length > 1) {
            this.parameters.replace();
        }
    }

    public getLink(full: boolean = false): string {
        let url = '';

        if (Object.keys(this.path).length > 1) {
            if (full) {
                $.each(this.path, (key: string, value: string) => {
                    url += key + '=' + value + '&';
                });
            } else if (this.path.link !== undefined) {
                url += this.path.link;
            }
        } else if (this.path.link !== undefined) {
            url += this.path.link;
        }

        if (this.highlight.length > 0) {
            url += '?highlight="' + this.highlight + '"';
        }

        if (this.hash.length > 0) {
            url += this.hash;
        }

        return url;
    }

    public replaceUrl(url: string = window.location.origin + '/?' + this.getLink(true)) {
        window.location.replace(url);
        throw '';
    }

    public redirectUrl(url: string = window.location.origin + '/?' + this.getLink(true)) {
        window.location.assign(url);
        throw '';
    }
}

export class CookieStore {
    public values: Record<string, string | null>;
    public enabled: boolean;
    public autofill: boolean;

    constructor() {
        this.values = { agree: null, lang: null, ch_lang: null, ch_system: null, ch_product: null, ch_version: null };
        this.enabled = navigator.cookieEnabled;
        this.autofill = false;

        if (!this.enabled) {
            return;
        }

        this.clearSelectorCookie();
    }

    public setCookie(reference: string, value: string | null) {
        if (value !== null) {
            this.values[reference] = value;
        }

        this.clearSelectorCookie();
    }

    public setElements() {
        const triggerStepSelection = (key: string, value: string) => {
            if (key === 'ch_version' || key === 'version') {
                const versionOption = $('.step1 .dropdown').children('[data-value="' + value + '"]');

                if (versionOption.length > 0) {
                    versionOption.first().trigger('click');
                }

                return;
            }

            $('.input .' + value).first().trigger('click');
        };

        const applySelections = (selections: Array<{ key: string; value: string | null | undefined }>) => {
            selections.forEach(({ key, value }) => {
                if (value !== null && value !== undefined && value.length !== 0 && value !== 'null') {
                    triggerStepSelection(key, value);
                }
            });
        };

        applySelections([
            { key: 'version', value: typeof runtime.query.parameters.version === 'string' ? runtime.query.parameters.version : null }
        ]);

        $.each([runtime.query.parameters.version], (index, value) => {
            if (typeof value === 'string') {
                $('.' + value).parents('.input').addClass('filled');
            }
        });
    }

    public refresh(reload: boolean = true) {
        if (this.enabled) {
            this.clearSelectorCookie();
        }

        if (reload) {
            window.location.reload();
        }
    }

    private clearSelectorCookie() {
        document.cookie = 'help=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    }
}

export const runtime = {} as {
    cookie: CookieStore;
    elements: any;
    query: Query;
};
